import * as base from "./base";
import * as derived from "./derived";

/**
 * Document metadata selectors namespace
 *
 * Usage:
 * - document.uid(state) - Get document UID
 * - document.name(state) - Get document name
 * - document.isLoaded(state) - Check if document is loaded
 * - document.ownerProfileUrl(state) - Get owner profile URL (memoized)
 */
export const document = {
    ...base,
    ...derived,
} as const;

export type DocumentSelectors = typeof document;
